
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import { harajukuCurryHyakuMeitenCurry3TopImage } from "@src/constants/images";
import InstaImage from "@src/components/InstaImage";
import { murakamiMasanori } from "@src/constants/authors";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import GoogleMap from "@src/components/GoogleMap";
import { meta as yogoroPageMeta } from "./yogoro.mdx";
import { meta as mokubazaPageMeta } from "./mokubaza.mdx";
import { meta as minoringoPageMeta } from "./minoringo.mdx";
export const meta = {
  path: "/media/harajuku/curry_hyaku_meiten",
  title: "【百名店限定】原宿カレーの名店はこの３つ！",
  description: "原宿のカレー百名店の中でも、特に異彩を放つ人気店を３つ厳選してご紹介します！原宿の人気カレー３選は全て食べログの評価が3.7以上のカレー屋さん。「お店の特徴」「人気メニュー」「支払い」など、選ぶ中で気になるところをまとめたので、原宿カレーの名店をご確認ください！",
  topImg: harajukuCurryHyakuMeitenCurry3TopImage,
  author: murakamiMasanori,
  tags: ["原宿", "有名店", "人気店", "まとめ記事", "食べログ高評価", "カレー"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`原宿のカレー百名店の中でも、特に異彩を放つ人気店、ヨゴロウ(YOGORO)、モクバザ(MOKUBAZA)、みのりんご の３つを厳選してご紹介します！全て食べログの評価が 3.7 以上のカレー屋さん。原宿でカレーならこの 3 店を抑えていたら大丈夫だと思いますので、その３点の「お店の特徴」「人気メニュー」「支払い」など、選ぶ中で気になるところをまとめてみました！原宿カレーの名店をご確認ください！`}</p>
    <h2>{`原宿・表参道 No.1 のカレー【ヨゴロウ(YOGORO)】`}</h2>
    <h3>{`原宿・表参道で No.1`}</h3>
    <InstaImage postId="B-Rq3-Zgk5-" mdxType="InstaImage" />
    <p>{`この後に紹介する「mokubaza」「みのりんご」も、原宿・表参道エリアでは個性派のカレーの名店として人気店。
しかし、ヨゴロウ(YOGORO)はその中でも異彩を放って、他のカレー屋を追随させていません。`}</p>
    <p>{`食べログ評価はなんと、`}<strong parentName="p">{`3.81(2020 年 5 月時点)`}</strong>{`で、2019 年には`}<strong parentName="p">{`百名店`}</strong>{`にも選出されています。`}</p>
    <h3>{`ヨゴロウ(YOGORO)にしかないオーナーが独自に創作した「ほうれん草カレー」`}</h3>
    <p>{`ヨゴロウ(YOGORO)のオーナーは、ヨゴロウ(YOGORO)をオープンする際に、他店のカレーを調査をしなかったそう。
「他店の味に惑わされたくない」という思いがあり、それが独特のカレーを生み出したのではないかと思います！
原宿でほうれん草のカレーはヨゴロウ(YOGORO)以外聞いたことないですもんね！`}</p>
    <h3>{`ほうれん草カレー(1,000 円)`}</h3>
    <InstaImage postId="B73O_LcA9fZ" mdxType="InstaImage" />
    <p>{`チキンは注文を受けてからニンニクで焼き上げるそうで、出来立ての香ばしいチキンとほうれん草のコクが合わさった味わいが楽しめます。`}</p>
    <h3>{`【限定５食】「ポークほうれん草カレー」(1,350 円)`}</h3>
    <InstaImage postId="B-HB4RjAl5A" mdxType="InstaImage" />
    <p>{`巨大なボークの肉塊と大根が乗ったインパクトのあるカレー。
ヨゴロウ(YOGORO)が１日に５色しか出さないカレーを提供している。
ジューシーで驚くほど柔らかいポークと、ルーのオイリーさを大根が吸収してバランスをとってくれる一品。`}</p>
    <h3>{`レトロな雰囲気の店内`}</h3>
    <p>{`ヨゴロウ(YOGORO)の店内は、落ち着いた木目調のテーブルやカウンターで全 12 席。
レトロでアットホームな雰囲気でカレーを食べるのはいいですよね！`}</p>
    <InstaImage postId="B-J3FweDqRJ" mdxType="InstaImage" />
    <hr></hr>
    <p><strong parentName="p">{`ヨゴロウ(YOGORO)についてもっと知りたい方はこちらへ ↓`}</strong></p>
    <LinkWithThumbnail meta={yogoroPageMeta} mdxType="LinkWithThumbnail" />
    <h3>{`支払い方法`}</h3>
    <p>{`電子マネー：×
クレカ：×
現金：○`}</p>
    <hr></hr>
    <h3>{`アクセス`}</h3>
    <p>{`原宿駅から徒歩 10 分の距離にあるので、少し歩きます。`}</p>
    <GoogleMap lat={35.6742184} lng={139.708765} mdxType="GoogleMap" />
    <hr></hr>
    <h2>{`芸術的なカレー【モクバザ(MOKUBAZA)】`}</h2>
    <InstaImage postId="B_Zs8p8AgTC" mdxType="InstaImage" />
    <h3>{`平日も休日も大行列の人気店`}</h3>
    <p>{`スノードームのようなキーマカレーを世の中に広めた、カレー界のフロンティア的な存在で、インスタにもたくさん写真が上がっています。
芸能人もそのカレーを求めて訪れるほどで、平日、休日問わずに大行列が並んでいることが多いです！`}</p>
    <p>{`食べログ評価は`}<strong parentName="p">{`3.75(2020 年 5 月時点)`}</strong>{`と高く、2019 年には`}<strong parentName="p">{`百名店`}</strong>{`にも選出されている人気店。`}</p>
    <h3>{`1 番人気はアボカドチーズキーマカレー`}</h3>
    <InstaImage postId="B5aeU1JgfTR" mdxType="InstaImage" />
    <p>{`たっぷりとかかったチーズの下に、きれいに配置されたアボカドがくっきりとわかる芸術的なカレー。
中央の卵を割るシーンが写真の３枚目に貼ってあるので、スライドして確認してみてくダサい！`}</p>
    <h4>{`アボカドチーズキーマカレーの値段`}</h4>
    <p>{`サイズごとに値段が異なるそうなので、確認してみてください！
S ：1,300 円
M ：1,350 円
L ：1,400 円`}</p>
    <p><strong parentName="p">{`モクバザ(MOKUBAZA)の詳細を確認したい方はこちらへ ↓`}</strong></p>
    <LinkWithThumbnail meta={mokubazaPageMeta} mdxType="LinkWithThumbnail" />
    <hr></hr>
    <h3>{`支払い方法`}</h3>
    <p>{`電子マネー：×
クレカ：×
現金：○`}</p>
    <hr></hr>
    <h3>{`アクセス`}</h3>
    <p>{`原宿駅から徒歩９分の距離で、ヨゴロウ(YOGORO)の近くにあります！`}</p>
    <GoogleMap lat={35.6742184} lng={139.7087655} mdxType="GoogleMap" />
    <hr></hr>
    <h2>{`たっぷりチーズのキーマカレー【みのりんご】`}</h2>
    <InstaImage postId="B93O8gSJ3-q" mdxType="InstaImage" />
    <p>{`どっさりとチーズがかかったキーマカレーを求めてたくさんの人が集まる原宿カレーの名店`}<strong parentName="p">{`みのりんご `}</strong>{`
原宿駅から徒歩 2 分という立地もあり、特に休日は１〜2 時間ほどの行列ができています！`}</p>
    <p>{`食べログ評価は`}<strong parentName="p">{`3.75(2020 年 5 月時点)`}</strong>{`と高く、2019 年には`}<strong parentName="p">{`百名店`}</strong>{`にも選出されている人気店。`}</p>
    <h3>{`これでもかというほどのチーズキーマカレー`}</h3>
    <InstaImage postId="B-vGPIyAXf4" mdxType="InstaImage" />
    <p>{`カレーからはみ出るほどとろとろのチーズを使ったキーマカレーが一番の人気メニュー！
`}<strong parentName="p">{`２枚目にスライド`}</strong>{`すると、中央からチーズを割る動画が見れますので、チームの分厚さを感じることができると思います。`}</p>
    <p>{`チーズと卵黄混ぜ合わせたまろやかな風味に、スパイスのきいたキーマカレーが程よく合わさります。
がっつり濃厚なチーズキーマカレーが食べたい方は、原宿`}<strong parentName="p">{`みのりんご`}</strong>{`へ！`}</p>
    <hr></hr>
    <p><strong parentName="p">{`みのりんごの詳細を確認したい方はこちらへ ↓`}</strong></p>
    <LinkWithThumbnail meta={minoringoPageMeta} mdxType="LinkWithThumbnail" />
    <h3>{`支払い方法`}</h3>
    <p>{`電子マネー：×
クレカ：×
現金：○`}</p>
    <hr></hr>
    <h3>{`アクセス`}</h3>
    <p>{`原宿駅から徒歩２分という抜群のアクセス！`}</p>
    <GoogleMap lat={35.6725187} lng={139.7013421} mdxType="GoogleMap" />
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`原宿カレーの百名店の中でも、食べログの評価が 3.7 以上の名店をご紹介させていただきました！どのカレーが一番ピンと来ましたか！？
ぜひ、原宿でカレーを探す際は、こちらを確認してみてください…！`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;